import {BankAccountList, BankAccountRestControllerApiFactory, BankMovementList, BankMovementRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Box, FormControl, InputLabel, MenuItem, Select, TableCell, Typography} from "@mui/material";
import {SoftChip} from "../../../../components/kit";
import {useApiManager} from "../../../../components/utils/api";
import {useEffect, useState} from "react";
import AdminInner from "../../../../components/layout/admin_inner";
import {fmtAmt} from "../../../../components/utils/numbers";
import {dateToString} from "../../../../components/utils/dates";

export const BankMovementListPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(BankMovementRestControllerApiFactory);

    const [bankAccounts, setBankAccounts] = useState<BankAccountList[]>([]);
    const [selectedAccountId, setSelectedAccountId] = useState<number | undefined>(undefined);
    const [trigger, setTrigger] = useState(0);

    useEffect(() => {
        const baCtrl = apiManager.factory(BankAccountRestControllerApiFactory);
        apiManager.execute(baCtrl.listBankAccount()).then(list => setBankAccounts(list));
    }, []);

    const listConfig: AppListConfig<BankMovementList> = {
        onClick: "/app/admin/accounting/bank-movement",
        headers: [
            {title: "Tipo", width: 90},
            {title: "Fecha", width: 100},
            {title: "Descripción"},
            {title: "Cuenta", width: 160},
            {title: "Importe", align: "right", width: 110},
            {title: "Asiento", width: 90},
        ],
        decorator: (bean: BankMovementList) => (
            <>
                <TableCell>
                    <SoftChip
                        label={bean.movementType === "COBRO" ? "Cobro" : bean.movementType === "PAGO" ? "Pago" : bean.movementType}
                        tone={bean.movementType === "COBRO" ? "success" : "error"}
                    />
                </TableCell>
                <TableCell sx={{fontVariantNumeric: "tabular-nums"}}>{dateToString(bean.movementDate)}</TableCell>
                <TableCell><Typography variant="body2" noWrap title={bean.description}>{bean.description}</Typography></TableCell>
                <TableCell>{(bean.bankAccount as any)?.name ?? bean.iban ?? "-"}</TableCell>
                <TableCell align="right">
                    <Typography variant="body2" fontWeight={700} sx={{fontVariantNumeric: "tabular-nums",
                        color: bean.movementType === "COBRO" ? "success.dark" : "text.primary"}}>
                        {fmtAmt(bean.amount)}
                    </Typography>
                </TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>
                    {bean.journalEntry?.entryNumber ?? "-"}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            return ctrl.pageBankMovement(currentPage, size, undefined, undefined, undefined, undefined, undefined, selectedAccountId, term, showDismissed);
        },
    };

    return (
        <AdminInner title="Movimientos bancarios">
            <Box sx={{mb: 2}}>
                <FormControl size="small" sx={{minWidth: {xs: "100%", sm: 320}, "& .MuiOutlinedInput-root": {borderRadius: 2}}}>
                    <InputLabel>Cuenta bancaria</InputLabel>
                    <Select
                        value={selectedAccountId ?? ""}
                        label="Cuenta bancaria"
                        onChange={e => {
                            const val = e.target.value;
                            const id = val === "" ? undefined : Number(val);
                            setSelectedAccountId(id);
                            setTrigger(t => t + 1);
                        }}
                    >
                        <MenuItem value=""><em>Todas las cuentas</em></MenuItem>
                        {bankAccounts.map(a => (
                            <MenuItem key={a.id} value={a.id}>{a.name}{a.iban ? ` — ${a.iban}` : ""}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <AppList config={listConfig} trigger={trigger} inner={false}/>
        </AdminInner>
    );
};
